module.exports = __webpack_public_path__ + "static/img_scene2-7cb6ab4bfed9de9a83d84102cad00240.png";